import { NextPage } from 'next'
import { useRouter } from 'next/router'
import React from 'react'
import ArticleTitle from '../../components/article/articleTitle.component'
import { Paragraph } from '../../components/article/contentItems.component'
import VideoItem from '../../components/article/videoItem.component'
import VideoYoutubeItem from '../../components/article/videoyoutubeItem.component'
import TagList, { Tag } from '../../components/tagList.component'
import { useAppContext } from '../../context/siteMapContext'
import { imageLoaderForStaticImages, parseYoutubeEmbeddedId } from '../../context/utils'
import useVideoGallery from '../../hooks/useVideoGallery'
import { IMedia, MediaTypeEnum } from '../../interfaces/media'
import { IVideoGallery } from '../../interfaces/videoGallery'
import Image from 'next/image'
import ColoredDivider from '../../components/coloredDivider.component'
import { ITag } from '../../interfaces/article'
import Head from 'next/head'

const VideoGalleryItem: React.FC<any> = ({ fileUrl, title, type, innerDescription, tags, isLast }) => {
  const { highContrastOn } = useAppContext();

  return (
    <div className='w-full flex flex-col'>
      <div className='w-full mt-24 mb-4'>
        {type === MediaTypeEnum.VIDEO ?
          (<VideoItem url={fileUrl} title={title}></VideoItem>) : (<VideoYoutubeItem url={parseYoutubeEmbeddedId(fileUrl)} title={title}></VideoYoutubeItem>)}
      </div>
      <div className='w-full'>
        <div style={{ fontWeight: 'bold' }}>
          <Paragraph content={title} />
        </div>
        {type === MediaTypeEnum.EMBEDDEDVIDEO &&
          (
            <div style={{ marginTop: '1em' }}>
              <Paragraph content={innerDescription} />
            </div>
          )
        }
      </div>
      {!!tags?.length && (
        <div className="w-full xl:w-4/5 pt-10 md:pt-20 xl:pt-0 mt-[12px]">
          <div className='xl:w-half-screen flex flex-wrap gap-1'>
            {tags.map((tag: ITag) => (
              <Tag name={tag.name} key={tag.name} />
            ))}
          </div>
        </div>
      )}
      {!isLast && <div className={`h-[3px] mt-[20px]  ${(highContrastOn ? 'bg-[#fff]' : 'bg-[#656a70]')}`} />}
    </div>
  )
}

const VideoGalleryContent: React.FC<IVideoGallery> = ({
  title,
  date,
  items,
  tags,
}) => {
  const mapItems = (video: IMedia, index: number) => <VideoGalleryItem {...video} isLast={index === items.length - 1} />
  return (
    <>
      <Head>
        <meta property="og:title" content={title} />
      </Head>
      <div className='w-full xl:w-2/3 flex flex-col xl:flex-row pt-8 '>
        <div className='w-full xl:w-1/8 font-medium font-montserrat'>
          <span className='white-space-nowrap'>{date}</span>
        </div>
        <div className='w-full xl:w-7/8 white-space-nowrap mt-10 xl:mt-20'>
          <ArticleTitle title={title} />
          {!!tags.length && (
            <div className='w-full xl:w-1/2 my-[20px]'>
              <div className='xl:w-half-screen flex flex-wrap gap-1'>
                {tags.map(({ name }) => (
                  <Tag name={name} key={name} />
                ))}
              </div>
            </div>
          )}
          <div className='z-2 relative h-[4px] w-full mt-[20px]'>
            <ColoredDivider />
          </div>
        </div>
      </div>
      <div className='w-full xl:w-1/2 flex flex-col gap-mobile xl:gap-desktop'>
        {!!items && items.length && <div className=''>{items.map(mapItems)}</div>}
      </div>

    </>
  )
}

const VideoGallery: NextPage = () => {
  const { query } = useRouter()

  const headingId = query?.contentId?.toString() || ''
  const videoGallery: IVideoGallery | undefined = useVideoGallery(headingId, location.search.includes('preview=1'))

  return (
    <>
      <div className='w-full ml-0 flex flex-col items-center'>
        <div className='w-full xl:w-2/3 flex flex-col xl:flex-row pt-8 '>
          {location.search.includes('preview=1') && <div className='text-[24pt] text-page-title-color font-semibold mb-12'>!!!Előnézet!!!</div>}
        </div>
      </div>
      <div className='w-full ml-0 flex flex-col items-center'>
        {!!videoGallery && <VideoGalleryContent {...videoGallery} />}
      </div>
    </>
  )
}

export default VideoGallery
